<div data-ng-include="'blocks/conference_logo.html'"></div>

<div class="wrapper-lg">
    <div class="padder-lg">

        <div data-ng-include="'blocks/conference_nav.html'"></div>

        <div class="m-t-lg">

            <table class="table table-condensed table-hover">
                <thead>
                    <th>Date Sent</th>
                    <th>Subject</th>
                    <th style="width: 100px">Action</th>
                </thead>
                <tbody>
                    <tr ng-repeat="communication in communications">
                        <td style="width: 150px">
                            {{formatMomentDate(communication.sent_at,'MMM D, YYYY')}} {{formatMomentDate(communication.sent_at,'h:mm A')}}
                        </td>
                        <td>
                            <a ng-click="loadCommunicationModal(communication.id)">
                                {{communication.subject_rendered}}
                            </a>
                        </td>
                        <td>
                            <a class="btn-success btn btn-xs" ng-click="loadCommunicationModal(communication.id)">
                                View
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>

    </div>
</div>